export default {"src":"/_next/static/media/endometriosis.88c4f79d.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};